import React from 'react'
import { InfoAreaColumn } from './style'

export default ({ grow = false, children, border }) => (
  <InfoAreaColumn grow={grow} border={border}>
    {children}
  </InfoAreaColumn>
)
